var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.8263H31.4488C31.0476 10.3379 30.4379 8.93534 29.6516 7.65234H16V11.8263Z",
    fill: "#338AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04142 28.5216H25.961C27.4212 27.3586 28.6734 25.946 29.6528 24.3477H2.34961C3.32905 25.9459 4.5813 27.3586 6.04142 28.5216Z",
    fill: "#338AF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56642 3.87158C4.30855 4.95477 3.22111 6.23033 2.34961 7.65258H5.56642V3.87158Z",
    fill: "#338AF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9996C16 14.3699 16 13.0059 16 11.8257H9.73913V15.9996H5.56519V11.8257H0.551188C0.1925 13.1566 0 14.5554 0 15.9996C0 17.4438 0.1925 18.8427 0.551188 20.1736H31.4489C31.8075 18.8427 32 17.4438 32 15.9996H16Z",
    fill: "#338AF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0011 0.000488281C13.7793 0.000488281 11.6634 0.453801 9.74023 1.27224V7.65268H16.0011C16.0011 6.19568 16.0011 4.95649 16.0011 3.47874H25.9609C23.2277 1.30199 19.7667 0.000488281 16.0011 0.000488281Z",
    fill: "#338AF3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.db920854071d9958908a7595519a0984.svg";
export { ForwardRef as ReactComponent };